// extracted by mini-css-extract-plugin
export default {"container":"getDescriptionWithActionsNode_container__pqlHj","actions":"getDescriptionWithActionsNode_actions__QZlEb"};